const TIVIGO_ENDPOINT_URL = 'https://tivigo.store/endpoint.php';

function buildEndpointUrl(endpoint, params = {}) {
  const query = new URLSearchParams({ endpoint });

  Object.entries(params).forEach(([key, value]) => {
    if (value === undefined || value === null || value === '') return;
    query.set(key, String(value));
  });

  return `${TIVIGO_ENDPOINT_URL}?${query.toString()}`;
}

async function requestEndpoint(endpoint, params, options = {}) {
  const response = await fetch(buildEndpointUrl(endpoint, params), options);
  return response.json();
}

export function requestTestAvailability(options = {}) {
  return requestEndpoint(
    'check_test_yayini_durumu',
    {},
    { cache: 'no-store', ...options }
  );
}

export function requestTrialEligibility(email, options = {}) {
  return requestEndpoint(
    'check_test_eligibility',
    { email: String(email ?? '').trim().toLowerCase() },
    options
  );
}

export function sendTrialRegisterCode({
  username,
  password,
  phone,
  email,
  ad = '',
  refCode = '',
}) {
  return requestEndpoint('send_trial_register_code', {
    username: String(username ?? '').trim(),
    password: String(password ?? '').trim(),
    phone: String(phone ?? '').replace(/\D/g, ''),
    email: String(email ?? '').trim().toLowerCase(),
    ad: String(ad ?? '').trim(),
    ref_code: String(refCode ?? '').trim(),
    registration_type: 'test',
  });
}

export function verifyTrialRegister({ email, code }) {
  return requestEndpoint('verify_trial_register', {
    email: String(email ?? '').trim().toLowerCase(),
    code: String(code ?? '').replace(/\D/g, '').slice(0, 4),
  });
}
